<ngx-spinner></ngx-spinner>
<div class="detail-box" *ngIf="purchaseData.length > 0">
  <div class="mobile_head pb-2">
    <h4>{{ "PURCHASE.PURCHASE_HISTORY" | translate }}</h4>
  </div>
  <div class="multi-slider mb-3">
    <div id="slider-top">
      <owl-carousel-o
        [options]="toprated"
        (dragging)="isDragging = $event.dragging"
      >
        <ng-container *ngFor="let purchase of purchaseData; let i = index">
          <ng-template carouselSlide [id]="purchase.public_id">
            <div class="series-box">
              <a
                [owlRouterLink]="purchase.content_info | redirectUrl"
                [stopLink]="isDragging"
              >
                <div class="ratio-slider ratio-16-9 view-content">
                  <img
                    src="{{
                      purchase.content_info?.thumbnails
                        | thumbnails: 'landscape'
                    }}"
                    [src-fallback]="app_constant.landscapeDefault"
                  />
                </div>
                <div class="slider-titles">
                  <h5 class="title">{{ purchase.content_info.name }}</h5>
                  <b>
                    <span class="text-white"
                      >$ {{ purchase.transaction_amt }}</span
                    >
                  </b>
                  <p class="sub-title">
                    <span class="pre_batch"> {{ purchase.status }}</span>
                    <span *ngIf="purchase.status === 'rental'">
                      {{ "PURCHASE.EXPIRE_ON" | translate }}
                      {{ purchase.expire_at | date: "MMM d, y, hh:mm a" }}</span
                    >
                    <span *ngIf="purchase.status === 'purchase'">
                      {{ "PURCHASE.BUY_DATE" | translate }}
                      {{
                        purchase.created_at | date: "MMM d, y, hh:mm a"
                      }}</span
                    >
                  </p>
                </div>
              </a>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</div>
